import { useContext, useEffect, useState } from "react";
import getCurrentUnidadeId from "../../funcs/getCurrentUnidadeId";
import apiRelatorio from "../../services/apis/apiRelatorio";
import CardLayout from "../../components/common/CardLayout";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../../components/ui/accordion";
import NoDataAlert from "../../components/common/returns/NoDataAlert";
import { DatePicker } from "../../components/ui/datepicker";
import { Button } from "../../components/ui/button";
import { GaugeChart } from "../../components/relatorio/GaugeChart";
import DefaultChartCompressor from "../../components/relatorio/DefaultChartCompressor1";
import DefaultChartCompressor2 from "../../components/relatorio/DefaultChartCompressor2";
import { getClientTimeZoneOffset } from "../../funcs";
import DateIntervalPopOver from "../../components/relatorio/DateIntervalPopOver";
import { FaFileExcel, FaSpinner } from "react-icons/fa";
import { ToastContext } from "../../contexts/ToastContext";
import apiUnidade from "../../services/apis/apiUnidade";

export default function Compressor() {
    const UNIDADE = getCurrentUnidadeId();
    const [dados, setDados] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [tempSelectedDate, setTempSelectedDate] = useState(new Date());
    const [isLoadingRelatorio, setIsLoadingRelatorio] = useState(false);
    const [unidade, setUnidade] = useState();
    const { erro } = useContext(ToastContext);

    useEffect(() => {
        const fetchData = async () => {
            const res = await apiUnidade.getById(UNIDADE);
            setUnidade(res.data);
        }
        fetchData();
    },[UNIDADE])

    const handleDateChange = (date) => {
        setTempSelectedDate(date);
    };

    const handleSearch = async () => {
        setSelectedDate(tempSelectedDate);
    };

    useEffect(() => {
        const fetchData = async () => {
            const dataFormatada = selectedDate?.toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });

            const timeZoneOffset = getClientTimeZoneOffset();

            const fusoData = {
                data: dataFormatada,
                TimeZoneNumber: timeZoneOffset
            }

            const res = await apiRelatorio.relatorioCompressor(UNIDADE, fusoData)
            setDados(res.data);
        }
        fetchData();
    }, [selectedDate, UNIDADE]);

    const gerarRelatorio = async (tempSelectedDateDe, tempSelectedDateAte) => {
        try {
            setIsLoadingRelatorio(true);
            const timeZoneOffset = getClientTimeZoneOffset();

            const dataInfo = {
                dataInicio: tempSelectedDateDe,
                dataFim: tempSelectedDateAte,
                TimeZoneNumber: timeZoneOffset
            }

            const dataInicioFormatada = dataInfo.dataInicio.toLocaleString('pt-BR', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
				hour12: false 
			}).replaceAll(",", "_").replaceAll(" ", "");

            const dataFinalFormatada = dataInfo.dataFim.toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            }).replaceAll(",", "_").replaceAll(" ", "");

            //se data inicio for maior que data final
            if (dataInfo.dataInicio > dataInfo.dataFim) {
                erro('Data de início precisa ser maior que data final');
                return;
            }

            const response = await apiRelatorio.relatorioLeituraCompressor(unidade.id, dataInfo);
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', `Leituras_Compressores_${unidade.nome}_${dataInicioFormatada}-${dataFinalFormatada}.xlsx`);

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            erro(error.message);
        } finally {
            setIsLoadingRelatorio(false);
        }
    }

    return (
        <section className="flex flex-col pb-16">
            <div className="flex items-center justify-center">
                <div className="flex justify-center items-center w-full p-4 gap-2">
                    <DatePicker
                        selectedDate={tempSelectedDate}
                        onDateChange={handleDateChange}
                    />
                    <Button onClick={handleSearch}>
                        Buscar
                    </Button>
                    <DateIntervalPopOver onGerarRelatorio={gerarRelatorio} disabled={isLoadingRelatorio}>
                        {
                            isLoadingRelatorio ? 
                            <div className="animate-spin">
                                <FaSpinner size={18} />
                            </div>
                            :
                            <FaFileExcel size={18} /> 
                        }
                        
                    </DateIntervalPopOver>
                </div>
                <div className="inline-flex w-32 justify-end px-2">
                    <p className="text-sm text-secondary drop-shadow-1xl">
                        {selectedDate
                            ? selectedDate.toLocaleDateString(
                                'pt-BR',
                                {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                }
                            )
                            : ''}
                    </p>
                </div>
            </div>
            <div className="flex flex-col gap-4 py-2">
                {

                    dados.map((compressor) => (
                        <CardLayout key={compressor.id}>
                            <Accordion
                                type="single"
                                defaultValue={`item-${compressor.id}`}
                                collapsible={true}
                            >
                                <AccordionItem
                                    value={`item-${compressor.id}`}
                                >
                                    <div className="font-semibold">
                                        <AccordionTrigger>
                                            <div className="w-full flex items-center justify-center text-sm lg:text-2xl drop-shadow-1xl">
                                                {compressor &&
                                                    <div
                                                        className={`uppercase`}
                                                    >
                                                        <p>
                                                            <span className="capitalize">
                                                                {
                                                                    compressor.nome
                                                                }
                                                            </span>
                                                        </p>
                                                    </div>
                                                }
                                            </div>
                                        </AccordionTrigger>
                                    </div>
                                    {
                                        compressor.leiturasCompressor.length === 0 ?
                                            <NoDataAlert /> :
                                            <AccordionContent>
                                                <div className="flex flex-col gap-4 px-4 items-center justify-center">
                                                    <div className="flex flex-wrap justify-center">
                                                        <GaugeChart valor={compressor.percentualCapacidade * 100} label={"Percentual de capacidade"} />
                                                        <GaugeChart valor={compressor.percentualPotencia * 100} label={"Percentual de potência"} />
                                                        <GaugeChart valor={compressor.leiturasCompressor.at(-1).eficiencia} label={"Eficiência"} />
                                                    </div>
                                                    <div className="flex text-center justify-center border-2 items-center border-accent rounded-full h-8 w-full max-w-[20rem] 3xl:px-4 my-2">
                                                        <p className="text-sm 3xl:text-lg font-bold px-4 text-accent">
                                                            I.E.E.:
                                                        </p>
                                                        <span className="font-bold drop-shadow-1xl text-white px-4 md:px-2 text-sm 3xl:text-lg">
                                                            {compressor.leiturasCompressor.at(-1).iee.toLocaleString(
                                                                'pt-BR',
                                                                {
                                                                    maximumFractionDigits: 2,
                                                                }
                                                            ) + " kcal/kwh"}
                                                        </span>
                                                    </div>
                                                    {
                                                        compressor.leiturasCompressor.length === 0 ?
                                                            <div className="flex flex-col gap-4 justify-center w-full items-center" key={compressor.id}>
                                                                <div className="w-[300px]">
                                                                    <NoDataAlert />
                                                                </div>
                                                            </div>
                                                            :
                                                            <>
                                                                <div className="flex flex-col sm:flex-row lg:flex-row justify-center items-center w-full px-2" key={compressor.id}>
                                                                    <div className="flex flex-col items-center w-full h-full 2xl:1/2">
                                                                        <DefaultChartCompressor chartDataProps={compressor} chartType={"compressor"} />
                                                                    </div>
                                                                    <div className="flex flex-col items-center w-full h-full 2xl:1/2">
                                                                        <DefaultChartCompressor2 chartDataProps={compressor} chartType={"compressor"} />
                                                                    </div>
                                                                </div>
                                                            </>
                                                    }
                                                </div>
                                            </AccordionContent>
                                    }
                                </AccordionItem>
                            </Accordion>
                        </CardLayout>
                    ))
                }
            </div>
        </section>
    );
}